import { createSlice } from '@reduxjs/toolkit'

import { addWishlist, getBasket, getInformations, getWishlist } from './actions'

export const initialState: any = {
  categories: {
    data: [],
    loading: false,
    error: null,
  },
  wishList: {
    data: [],
    loading: false,
    error: null,
    meta: {},
  },
  basket: {
    data: [],
    loading: false,
    error: null,
  },
  information: {
    data: [],
    loading: false,
    error: null,
  },
}

const wishlistSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(addWishlist.pending, state => {
      state.categories.loading = true
      state.categories.error = null
    })
    builder.addCase(addWishlist.fulfilled, (state, { payload }) => {
      state.categories.loading = false
      state.categories.data = payload
    })
    builder.addCase(addWishlist.rejected, (state, { payload }) => {
      state.categories.loading = false
      state.categories.error = payload as null
    })

    builder.addCase(getWishlist.pending, state => {
      state.wishList.loading = true
      state.wishList.error = null
    })
    builder.addCase(getWishlist.fulfilled, (state, { payload }) => {
      state.wishList.loading = false
      state.wishList.data = payload.data
      state.wishList.meta = payload.meta
    })
    builder.addCase(getWishlist.rejected, (state, { payload }) => {
      state.wishList.loading = false
      state.wishList.error = payload as null
    })

    builder.addCase(getBasket.pending, state => {
      state.basket.loading = true
      state.basket.error = null
    })
    builder.addCase(getBasket.fulfilled, (state, { payload }) => {
      state.basket.loading = false
      state.basket.data = payload
    })
    builder.addCase(getBasket.rejected, (state, { payload }) => {
      state.basket.loading = false
      state.basket.error = payload as null
    })

    builder.addCase(getInformations.pending, state => {
      state.information.loading = true
      state.information.error = null
    })
    builder.addCase(getInformations.fulfilled, (state, { payload }) => {
      state.information.loading = false
      state.information.data = payload
    })
    builder.addCase(getInformations.rejected, (state, { payload }) => {
      state.information.loading = false
      state.information.error = payload as null
    })
  },
})

export const { name, actions } = wishlistSlice

const wishlistReducer = wishlistSlice.reducer

export default wishlistReducer
